// Tiny event bus for wallet-related modals.
// Used by the axios interceptor to surface 402 responses to globally-mounted
// modals without prop-drilling or coupling axios to React state.
//
// Events emitted:
//   "insufficient_credits"  payload: { balance, required, action_url, message, feature_code? }
//   "subscription_lapsed"   payload: { action_url, message }
//   "storage_cap_exceeded"  payload: { used_bytes, cap_bytes, incoming_bytes, action_url, message }
//   "wallet_locked"         payload: { message }
//   "wallet_changed"        payload: {} — emitted after any successful credit-debit so the badge refetches
//
// Modals call subscribe() in useEffect and unsubscribe on unmount.

const _listeners = new Map(); // event_name -> Set<callback>

export function subscribe(event, cb) {
  if (!_listeners.has(event)) _listeners.set(event, new Set());
  _listeners.get(event).add(cb);
  return () => _listeners.get(event)?.delete(cb);
}

export function emit(event, payload = {}) {
  const set = _listeners.get(event);
  if (!set) return;
  set.forEach((cb) => {
    try { cb(payload); } catch (e) { console.error(`walletEvents listener for ${event} threw:`, e); }
  });
}
